export const HEALTH = {
  LIVE: ["Live", "bg-success/15 text-success", "#059669"],
  STALE: ["Stale", "bg-ochre/15 text-ochre", "#C8A24A"],
  OFFLINE: ["Offline", "bg-danger/15 text-danger", "#6b7280"],
  DENIED: ["Permission denied", "bg-danger/15 text-danger", "#6b7280"],
  UNAVAILABLE: ["Unavailable", "bg-danger/15 text-danger", "#6b7280"],
  ERROR: ["Error", "bg-danger/15 text-danger", "#6b7280"],
  PENDING: ["Not confirmed", "bg-muted text-muted-foreground", "#6b7280"],
  OFF_DUTY: ["Off duty", "bg-muted text-muted-foreground", "#6b7280"],
};
const DUTY = { WORKING: ["Working", "bg-success/15 text-success"], ON_BREAK: ["On Break", "bg-ochre/15 text-ochre"], OFF_DUTY: ["Off Duty", "bg-muted text-muted-foreground"] };

const Pill = ([label, cls], testid) => <span className={`text-[11px] font-bold rounded-full px-2 py-0.5 whitespace-nowrap ${cls}`} data-testid={testid}>{label}</span>;
export const HealthPill = ({ value }) => Pill(HEALTH[value] || [value, "bg-muted"], "tracking-health-pill");
export const DutyPill = ({ value }) => Pill(DUTY[value] || [value, "bg-muted"], "duty-status-pill");
export const ago = (s) => (s == null ? "never" : s < 60 ? `${s}s ago` : s < 3600 ? `${Math.round(s / 60)} min ago` : `${Math.round(s / 3600)} h ago`);
